import { useState } from "react";
import { TableDataField } from "../../Table/DataTable"
import ImageToggle from "../../Buttons/ImageToggle";
import TruthTable from "../../Data/TruthTable";
import PlotlyGraphs from "../../Data/PlotlyGraphs";

export default function PlotComponent({
    plotFields,
}: {
    plotFields: TableDataField[],
}) {
    const [ selectedIndex, setSelectedIndex ] = useState(0);


    return (
        <div className="w-full flex flex-col justify-start items-end gap-3 p-6">
            {plotFields.length > 1 && (
                <ImageToggle 
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex}
                    totalIndices={plotFields.length}
                />
            )}

            {plotFields.map((plot, i) => {
                if (i === selectedIndex) {
                    return (
                        <>
                        {plot.associatedColumn === 'truthTable' ? (
                            <TruthTable 
                                data={plot.value as { name: string, value: number }[]}
                            />
                        ) : (
                            <PlotlyGraphs 
                                data={plot.value as Plotly.Data[]}
                                type={
                                    plot.associatedColumn === 'roc' ? 'roc' 
                                    : plot.associatedColumn === 'overlay' ? 'histogram'
                                    : plot.associatedColumn === 'cross_val_predict' ? 'scatter'
                                    : 'scatter'
                                }
                                isSquare={true}
                            />
                        )}
                        </>
                    )
                } else {
                    return null
                }
            })}

        </div>
    )
}